export const STATIC_ICON_LIST = Object.freeze({
  videoOpaque: 'video-opaque',
});
